import request from '../../../../../services/axios';
import {ICashBackCard} from './cashBackCards.types';

export const getCashBackCards = async () => {
  const {data}: {data: ICashBackCard[]} = await request.get(
    '/api/v2/payment/cashback/cards',
  );

  return data;
};
